export const taskManagementPathName = "/task-mgmt";
